module.exports = __webpack_public_path__ + "static/media/KarmaIconGrayScale.84e4b4d5.png";